/* ========================================================================
   Sticky Elements
 ========================================================================== */

app.stickyElements = (function () {
  'use strict';

  let sticky;
  const _stickyElements = document.querySelectorAll('[data-sticky-element]');

  function init() {
    sticky = new Sticky('[data-sticky-element]');

    updateElements();

    window.addEventListener(
      'resize',
      function () {
        debounceUpdate();
      },
      { passive: true }
    );
  }

  // debounce
  let debounceTimer;

  function debounceUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      updateElements();
    }, 250);
  }

  function updateElements() {
    _stickyElements.forEach((element) => {
      const breakpoint = parseInt(element.getAttribute('data-sticky-for'));
      const mq = window.matchMedia(`(min-width: ${breakpoint}px)`);
      element.setAttribute('data-sticky-style', mq.matches);
      sticky.update();
    });
  }

  // Expose public functions and variables
  return {
    init: init,
  };
})();
